import { createAsyncThunk } from "@reduxjs/toolkit";
import CaseNoteAPI, { CaseNote, UpdateCaseNoteRequest } from "../api/CaseNote";

export const createCaseNote = createAsyncThunk<
    CaseNote,
    CaseNote,
    {rejectValue: void}
>(
    'caseNote/create',
    async (caseNote, {rejectWithValue}) => {
        try {
            await CaseNoteAPI.create(caseNote);
            return caseNote;
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)

export const updateCaseNote = createAsyncThunk<
    void,
    {caseId: string, type: string, request: UpdateCaseNoteRequest},
    {rejectValue: void}
>(
    'caseNote/update',
    async ({caseId, type, request}, {rejectWithValue}) => {
        try {
            await CaseNoteAPI.upsert(caseId, type, request);
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)